function scrollToSection(id) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll("a.nav-links");
    const langButton = document.querySelector(".lang-button");
    const langMenu = document.querySelector(".lang-menu");

    // 🔹 Aktif link güncelleme (scroll + tık)
    function updateActiveLink() {
      let current = "";
      document.querySelectorAll(".header, .services, .teams").forEach((section) => {
        const sectionTop = section.offsetTop - 120;
        if (window.scrollY >= sectionTop) {
          current = section.getAttribute("id");
        }
      });

      navLinks.forEach((link) => {
        const href = link.getAttribute("href");
        if (!href || !href.startsWith("#")) return;
        const hrefId = href.replace("#", "");
        link.classList.remove("active");
        if (hrefId === current) {
          link.classList.add("active");
        }
      });
    }

    window.addEventListener("scroll", updateActiveLink);
    window.addEventListener("load", updateActiveLink);

    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        navLinks.forEach((l) => l.classList.remove("active"));
        link.classList.add("active");
      });
    });

    updateActiveLink();

    // 🔹 Dil menüsü aç/kapa
    langButton.addEventListener("click", () => {
      langMenu.classList.toggle("show");
    });

    document.addEventListener("click", (e) => {
      if (!langButton.contains(e.target) && !langMenu.contains(e.target)) {
        langMenu.classList.remove("show");
      }
    });

    // 🔹 Dil algılama + çeviri
    const defaultLang = navigator.language.startsWith("tr") ? "tr" : "en";
    const savedLang = localStorage.getItem("lang") || defaultLang;

    setLanguage(savedLang);

    document.querySelectorAll(".lang-menu a").forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const selectedLang = this.getAttribute("href").split("=")[1];
        localStorage.setItem("lang", selectedLang);
        setLanguage(selectedLang);
        langMenu.classList.remove("show");
      });
    });
  });

  async function setLanguage(lang) {
    const res = await fetch("lang.json");
    const translations = await res.json();
    const content = translations[lang];

    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.getAttribute("data-i18n");
      if (content[key]) {
        el.textContent = content[key];
      }
    });

    // Dil bayrağını güncelle
    const flag = `images/icons/${lang}.png`;
    document.querySelector(".lang-button").innerHTML = `<img src="${flag}" class="flag"> ${lang.toUpperCase()} ▼`;

    localStorage.setItem("lang", lang);
  }
